import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import {
  handleErrorMessage,
  openInfoNotification,
  openSuccessNotification,
} from "helpers/methods";
import { useState } from "react";
import {
  deleteArchiveContact,
  softDeleteContact,
} from "screens/Contacts/ContactsService";

interface CustomProps {
  isVisible: boolean;
  handleDialogClose: Function;
  contact: any;
  getContactData: any;
}

const ContactDelateModal = (props: CustomProps) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const res =
        +props?.contact?.status === 4
          ? await deleteArchiveContact([props.contact.id])
          : await softDeleteContact([props?.contact.id]);
      openSuccessNotification(res.message);
      props.handleDialogClose();
      await props.getContactData();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const getDialogHeader = () => {
    return (
      <>
        <Typography variant="h4" color="#7551D0">
          Delete contact
        </Typography>
      </>
    );
  };

  const getBody = () => {
    return (
      <>
        <Stack spacing={3} pt={1}>
          <Typography textAlign="center">
            Deleting contact is permanent and cannot be undone. Are you sure you
            want to delete this contact?
          </Typography>
        </Stack>
      </>
    );
  };
  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="contacts_add__cancel_btn"
          variant="outlined"
          size="small"
          onClick={() => props.handleDialogClose()}
        >
          Cancel
        </Button>
        <Button
          id="contacts_add_save_btn"
          variant="contained"
          size="small"
          onClick={() => handleDelete()}
        >
          Delete
        </Button>
      </Stack>
    );
  };

  return (
    <>
      <CustomLoader isLoading={isLoading} />
      <CustomDialog
        handleDialogClose={props.handleDialogClose}
        isDialogOpen={props.isVisible}
        title={getDialogHeader()}
        body={getBody()}
        footer={getFooter()}
        closeButtonVisibility
        closable
        persistOnClickOutside
      />
    </>
  );
};

export default ContactDelateModal;
